import { AccessGuids, ConfigSystemParams } from 'src/app/core/consts';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { CompanyClickedEvent, GlobalEventService, IccidClickedEvent } from 'src/app/core/services/utelize/general/global-event-service';
import { CompanyModalFormComponent } from 'src/app/forms-modal/_company/company-modal-form/company-modal-form.component';
import { Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ComponentAccessUserService } from 'src/app/core/services/utelize/system/component-access/component-access-user-service';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { environment } from 'src/environments/environment';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { LocationServicesAccessService } from 'src/app/core/services/utelize/access/location-services/location-services-access.service';
import { ManageEsimModalFormComponent } from 'src/app/forms-modal/_manage-sim/manage-esim-modal-form/manage-esim-modal-form.component';
import { MdmAccessService } from 'src/app/core/services/utelize/access/device-management/mdm-access.service';
import { MdmHealthReportAccessService } from 'src/app/core/services/utelize/access/device-management/mdm-health-report-access.service';
import { MenuItem } from './menu.model';
import { NavigationEnd, Router } from '@angular/router';
import { PlatformInviewService } from 'src/app/core/services/utelize/general/platform-inview-service';
import { RiskIntelligenceAccessService } from 'src/app/core/services/utelize/access/risk-intelligence/risk-intelligence-access.service';
import { SideBarMenuComponent } from './menu';
import { SignalsAccessService } from 'src/app/core/services/utelize/access/signals/signals-access.service';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { TravelRiskManagementAccessService } from 'src/app/core/services/utelize/access/risk-intelligence/travel-risk-management-access.service';
import { WarningModalNRFormComponent } from 'src/app/forms-modal-confirmation/warning-modal-form/warning-modal-form.component';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})

export class SidebarComponent implements OnDestroy, OnInit {

  @Output() mobileMenuButtonClicked = new EventEmitter();

  @ViewChild('companyModalForm',    { static: false }) companyModalForm!   : CompanyModalFormComponent;
  @ViewChild('manageEsimModalForm', { static: false }) manageEsimModalForm!: ManageEsimModalFormComponent;
  @ViewChild('sideMenu')                               sideMenu!           : ElementRef;
  @ViewChild('warningModalForm',    { static: false }) warningModalForm!   : WarningModalNRFormComponent;

  get sureSimLogoGrow() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.SureSimLogoGrow,            false) &&
                                 !this.componentAccessUserService.hasAccessGuid(AccessGuids.AnimationSureSimLogoGrowGuard, true );  }

  private accessGuidsChangedSub    : Subscription | undefined;
  private companyClickedOnCancelled: (() => void) | undefined;
  private companyClickedOnSaved    : ((sureSimCompanyId: number | undefined) => void) | undefined;
  private companyClickedSub        : Subscription | undefined;
  private iccidClickedOnCancelled  : (() => void) | undefined;
  private iccidClickedOnSaved      : (() => void) | undefined;
  private iccidClickedSub          : Subscription | undefined;
  private menuComponent            : SideBarMenuComponent;
  private modeSubscription         : Subscription | undefined;

  public isPlatformModeInview: boolean   =environment.platformModeInview;
  public menuItems           : MenuItem[]=[];

  constructor(
    private authenticationService            : AuthenticationService,
    private componentAccessUserService       : ComponentAccessUserService,
    private configSystemService              : ConfigSystemService,
    private exceptionsService                : ExceptionsService,
    private globalEventService               : GlobalEventService,
    private locationServicesAccessService    : LocationServicesAccessService,
    private mdmAccessService                 : MdmAccessService,
    private mdmHealthReportAccessService     : MdmHealthReportAccessService,
    private platformInviewService            : PlatformInviewService,
    private riskIntelligenceAccessService    : RiskIntelligenceAccessService,
    private router                           : Router,
    private signalsAccessService             : SignalsAccessService,
    private travelRiskManagementAccessService: TravelRiskManagementAccessService,

    public translate: TranslateService
  ) {
    translate.setDefaultLang('en');
    this.menuComponent=new SideBarMenuComponent(this.authenticationService,
                                                this.componentAccessUserService,
                                                this.configSystemService,
                                                this.exceptionsService,
                                                this.locationServicesAccessService,
                                                this.mdmAccessService,
                                                this.mdmHealthReportAccessService,
                                                this.platformInviewService,
                                                this.riskIntelligenceAccessService,
                                                this.signalsAccessService,
                                                this.travelRiskManagementAccessService);
  }

  public async ngOnInit(): Promise<void> {
    try {
      //CRN_20251222 - Config params are loaded in AppComponent.ngOnInit()

      // const data=await firstValueFrom(this.configSystemService.getEncrypted()
      //                  .pipe(
      //                    catchError((error) => throwError(() => new Error(this.exceptionsService.formatHttpError(error))))
      //                  ));
      
      // this.configSystemService.allParamsAndValues=data;
      
      this.menuItems=this.menuComponent.Menu();

      this.menuComponent.Init().then(() => {
        this.menuItems=this.menuComponent.Menu();
      });

      this.companyClickedSub=this.globalEventService.companyClicked$.subscribe({
        next : (event: CompanyClickedEvent) => {
          if (this.companyModalForm.isCompanyFormOpen) {
            this.warningModalForm.openForm("Company Form Already Open", "A company form is already open, close this form to return to it");
          } else {
            this.companyClickedOnCancelled=event.onCancelled;
            this.companyClickedOnSaved    =event.onSaved;
            this.companyModalForm.openForm(event.companyId, event.openOnLocationTab);
          }
        },
        error: error => { this.exceptionsService.handleException(new Error(error)); }
      });

      this.iccidClickedSub=this.globalEventService.iccidClicked$.subscribe({
        next : (event: IccidClickedEvent) => {
          if (this.manageEsimModalForm.isSimFormOpen) {
            this.warningModalForm.openForm("Manage SIM Already Open", "A manage ICCID form is already open, close this form to return to it");
          } else {
            this.iccidClickedOnCancelled=event.onCancelled;
            this.iccidClickedOnSaved    =event.onSaved;
            this.manageEsimModalForm.openFormByIccid(event.iccid, event.openOnLocationTab);
          }
        },
        error: error => { this.exceptionsService.handleException(new Error(error)); }
      });

      //CRN_20260407 - Refresh menu when platform mode changes

      if (this.isPlatformModeInview) {
        this.modeSubscription=this.platformInviewService.mode().subscribe(() => {
          this.menuItems=this.menuComponent.Menu();
          setTimeout(() => { this.initActiveMenu(); }, 0);
        });
      }

      this.accessGuidsChangedSub=this.globalEventService.accessGuidsChanged$.subscribe({
        next : () => {
          this.menuItems=this.menuComponent.Menu();
          setTimeout(() => { this.initActiveMenu(); }, 0);
        },
        error: error => { this.exceptionsService.handleException(new Error(error)); }
      });

      this.router.events.subscribe((event) => {
        if (document.documentElement.getAttribute('data-layout') != "twocolumn") {
          if (event instanceof NavigationEnd) {
            this.initActiveMenu();
          }
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngOnDestroy(): void {
    try {
      this.accessGuidsChangedSub?.unsubscribe();
      this.companyClickedSub?.unsubscribe();
      this.iccidClickedSub?.unsubscribe();
      this.modeSubscription?.unsubscribe();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  /***
   * Activate droup down set
   */
  ngAfterViewInit() {
    setTimeout(() => {
      this.initActiveMenu();
    }, 0);
  }

  removeActivation(items: any) {
    items.forEach((item: any) => {
      item.classList.remove("active");
    });
  }

  toggleItem(item: any) {
    this.menuItems.forEach((menuItem: any) => {

      if (menuItem == item) {
        menuItem.isCollapsed = !menuItem.isCollapsed
      } else {
        menuItem.isCollapsed = true
      }
      if (menuItem.subItems) {
        menuItem.subItems.forEach((subItem: any) => {

          if (subItem == item) {
            menuItem.isCollapsed = !menuItem.isCollapsed
            subItem.isCollapsed = !subItem.isCollapsed
          } else {
            subItem.isCollapsed = true
          }
          if (subItem.subItems) {
            subItem.subItems.forEach((childitem: any) => {

              if (childitem == item) {
                childitem.isCollapsed = !childitem.isCollapsed
                subItem.isCollapsed = !subItem.isCollapsed
                menuItem.isCollapsed = !menuItem.isCollapsed
              } else {
                childitem.isCollapsed = true
              }
              if (childitem.subItems) {
                childitem.subItems.forEach((childrenitem: any) => {

                  if (childrenitem == item) {
                    childrenitem.isCollapsed = false
                    childitem.isCollapsed = false
                    subItem.isCollapsed = false
                    menuItem.isCollapsed = false
                  } else {
                    childrenitem.isCollapsed = true
                  }
                })
              }
            })
          }
        })
      }
    });
  }

  activateParentDropdown(item: any) {
    item.classList.add("active");
    let parentCollapseDiv = item.closest(".collapse.menu-dropdown");

    if (parentCollapseDiv) {
      parentCollapseDiv.parentElement.children[0].classList.add("active");
      if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
        if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling)
          parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.classList.add("active");
        if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse")) {
          parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse").previousElementSibling.classList.add("active");
        }
      }
      return false;
    }
    return false;
  }

  updateActive(event: any) {
    const ul = document.getElementById("navbar-nav");
    if (ul) {
      const items = Array.from(ul.querySelectorAll("a.nav-link"));
      this.removeActivation(items);
    }
    this.activateParentDropdown(event.target);
  }

  initActiveMenu() {
    let pathName = window.location.pathname;
    // Check if the application is running in production
    if (environment.production) {
      // Modify pathName for production build
      pathName = pathName.replace('/velzon/angular/default', '');
    }

    const active = this.findMenuItem(pathName, this.menuItems)
    this.toggleItem(active)
    const ul = document.getElementById("navbar-nav");
    if (ul) {
      const items = Array.from(ul.querySelectorAll("a.nav-link"));
      let activeItems = items.filter((x: any) => x.classList.contains("active"));
      this.removeActivation(activeItems);

      let matchingMenuItem = items.find((x: any) => {
        if (environment.production) {
          let path = x.pathname
          path = path.replace('/velzon/angular/default', '');
          return path === pathName;
        } else {
          return x.pathname === pathName;
        }

      });
      if (matchingMenuItem) {
        this.activateParentDropdown(matchingMenuItem);
      }
    }
  }

  private findMenuItem(pathname: string, menuItems: any[]): any {
    for (const menuItem of menuItems) {
      if (menuItem.link && menuItem.link === pathname) {
        return menuItem;
      }

      if (menuItem.subItems) {
        const foundItem = this.findMenuItem(pathname, menuItem.subItems);
        if (foundItem) {
          return foundItem;
        }
      }
    }

    return null;
  }
  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    var sidebarsize = document.documentElement.getAttribute("data-sidebar-size");
    if (sidebarsize == 'sm-hover-active') {
      document.documentElement.setAttribute("data-sidebar-size", 'sm-hover');

    } else {
      document.documentElement.setAttribute("data-sidebar-size", 'sm-hover-active')
    }
  }

  /**
   * SidebarHide modal
   * @param content modal content
   */
  SidebarHide() {
    document.body.classList.remove('vertical-sidebar-enable');
  }

  public onCompanyDataSaved(sureSimCompanyId: number | undefined): void {
    try {
      this.companyClickedOnCancelled=undefined;
      this.companyClickedOnSaved?.(sureSimCompanyId);
      this.companyClickedOnSaved    =undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onCompanyFormCancelled(): void {
    try {
      this.companyClickedOnSaved    =undefined;
      this.companyClickedOnCancelled?.();
      this.companyClickedOnCancelled=undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onIccidFormCancelled(): void {
    try {
      this.iccidClickedOnSaved    =undefined;
      this.iccidClickedOnCancelled?.();
      this.iccidClickedOnCancelled=undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onIccidFormSaved(): void {
    try {
      this.iccidClickedOnCancelled=undefined;
      this.iccidClickedOnSaved?.();
      this.iccidClickedOnSaved    =undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public isImageIcon(icon: string | undefined | null): boolean {
    try {
      if (!icon)
        return false;
    
      const lower=icon.toLowerCase();
    
      return lower.includes('/') ||
             lower.startsWith('assets/') ||
             lower.startsWith('src/assets/') ||
             lower.endsWith('.jpeg') ||
             lower.endsWith('.jpg') ||
             lower.endsWith('.gif') ||
             lower.endsWith('.png') ||
             lower.endsWith('.svg') ||
             lower.endsWith('.webp');
        }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public normaliseIconPath(icon: string): string {
    try {
      if (icon.startsWith('src/'))
        return icon.replace(/^src\//, '');
    
      return icon;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return icon;
    }
  }
}
